import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { KanbanViewCardI, KanbanViewListI } from '../../models/kanban-view/kanban-viewI';
import { KanbanAddEditSwimLaneComponent } from '../kanban-add-edit-swimlane/kanban-add-edit-swimlane.component';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import * as moment from 'moment';

@Component({
  selector: 'anterasoftware-quote-view-container',
  templateUrl: './quote-view-container.component.html',
  styleUrls: ['./quote-view-container.component.scss']
})
export class QuoteViewContainerComponent implements OnInit {

  @Input() public swimLaneList: KanbanViewListI[] = [];
  @Input() public dateFormatString: string = 'YYYY-MM-DD';
  @Input() public timeFormatString: string = 'hh:mm a';

  @Output() public onSwimLaneChange: EventEmitter<any> = new EventEmitter();
  @Output() public onDeleteSwimLane: EventEmitter<any> = new EventEmitter();
  @Output() public selectClicked: EventEmitter<any> = new EventEmitter();
  @Output() public onDrop: EventEmitter<any> = new EventEmitter();
  @Output() public onEditQuote: EventEmitter<any> = new EventEmitter();
  @Output() public updateQuoteStatus: EventEmitter<any> = new EventEmitter();

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  public openSwimLaneDialog(panel?: KanbanViewListI) {
    let dialogRef = this.dialog.open(KanbanAddEditSwimLaneComponent, {
      width: '500px',
      height: '450px',
      panelClass: 'antera-details-dialog',
      data: {
        panel: panel,
        swimlaneLength: this.swimLaneList.length
      },
    });

    dialogRef.afterClosed().subscribe((formValues: any) => {

      if (formValues) {
        this.onSwimLaneChange.emit(formValues);
      }
    });
  }

  /**
   * Deletes swimlane which is selected.
   *
   * @returns {void}
   */
  public deleteSwimLane(swimLane:any): void {
    if(swimLane.id) {
      this.onDeleteSwimLane.emit(swimLane);
    }
  }

  public cardValueChange(card: KanbanViewCardI, swimLaneIndex: number, cardIndex: number){
    // don't need this ngModel handles
    // this.swimLaneList[swimLaneIndex].cards[cardIndex] = card;
    //this.onSwimLaneChange.emit(this.swimLaneList);
    this.swimLaneList[swimLaneIndex].cards[cardIndex] = card;
    this.selectClicked.emit(this.swimLaneList);
  }

  public onToggleAll(event: MatCheckbox, swimLaneIndex: number){
    this.swimLaneList[swimLaneIndex]?.cards.forEach((card: KanbanViewCardI) => card.select = event.checked);
    this.selectClicked.emit(this.swimLaneList);
  }

  drop(event: any,swimLane:KanbanViewListI) {
    if(event && event.value) {
      if(swimLane && swimLane.header && swimLane.header.name) {
        
        event.value.kanbanStatus = swimLane.header.name;
      }
    
      this.updateQuoteStatus.emit(event.value);
    }
  }

  editCardDetails(quote: any) {
    this.onEditQuote.emit(quote);
  }
}
